import { combineReducers } from "redux";
import AppReducer from "./AppReducer";
import UserReducer from "./userReducer";
import DataReducer from "./dataReducer";
import SearchReducer from "./searchReducer";
import ProfileReducer from "./profileReducer";
import MatchesReducer from "./matchesReducer";
import MessagingReducer from "./messaginReducer";

const rootReducer = combineReducers({
  app: AppReducer,
  user: UserReducer,
  data: DataReducer,
  search: SearchReducer,
  profile: ProfileReducer,
  matches: MatchesReducer,
  messaging: MessagingReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js